import React, { Component } from "react";
import { IonPage, IonHeader, IonToolbar, IonTitle, IonContent, IonButton } from "@ionic/react";

// css
import "../Shared.css";
import "../../App.css";
import "./GuidelineCell.css";

// controllers
import {
  IScreenProps,
  IUser,
  IGuideline,
  IGuidelineSummary,
  IAlgorithm,
  IAnnotation,
  IPGDAck,
  IGLAck,
} from "../Interfaces";
import DataController from "../controllers/DataController";

// images
import indicatorBookmark from "../assets/Button_Bookmark_3Small@3x.png";

type Props = {
  guidelineSummary?: IGuidelineSummary;
  algorithm?: IAlgorithm;
  bookmarked: boolean;
  updated: boolean;
  searchText?: string;
  userTrust: string;
  pgdAck?: IPGDAck | null;
  glAck?: IGLAck | null;
  referenceCardImageName?: string | null;
  inAlgorithmList?: boolean;
  screenProps: IScreenProps;
  cellClicked?: (id: string, type: "guideline" | "algorithm") => void;
};
type State = {};

class GuidelineCell extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
  }

  cellClicked() {
    let id = "";
    let type: "guideline" | "algorithm" = "guideline";

    if (this.props.guidelineSummary != null) {
      id = this.props.guidelineSummary.GLID;
    }

    if (this.props.algorithm != null) {
      id = this.props.algorithm.id;
      type = "algorithm";
    }

    if (this.props.cellClicked) {
      this.props.cellClicked(id, type);
    }
  }

  render() {
    let titleText = "";
    let lowerText = "";
    let headerClass = "";
    let bottomBarText = "";
    let bottomBarClass = DataController.getSectionClass(this.props.userTrust);
    let acknowledgementText = "";
    let acknowledgementClass = "";
    let pgdText = "";
    let isExcluded = false;

    let guidelineSummary = this.props.guidelineSummary;
    if (guidelineSummary != null) {
      if (guidelineSummary.Title) {
        titleText = guidelineSummary.Title;
      }
      headerClass = DataController.getGuidelineClass(guidelineSummary);

      if (DataController.isDrug(guidelineSummary)) {
        if (this.props.guidelineSummary != null && this.props.guidelineSummary.SubTitle) {
          lowerText = this.props.guidelineSummary.SubTitle;
        }
      }

      if (DataController.isPageForAge(guidelineSummary.GLID)) {
        titleText = "Page for Age";
        if (guidelineSummary.Title) {
          lowerText = guidelineSummary.Title.substr(14);
        }
      }

      if (guidelineSummary.trust) {
        bottomBarText = DataController.getTrustDisplayName(guidelineSummary.trust);

        if (guidelineSummary.Section === "") {
          headerClass = DataController.getSectionClass(guidelineSummary.trust);
        }
      }

      if (DataController.isSharedProcedure(guidelineSummary)) {
        bottomBarText = "Shared Procedure";
        bottomBarClass = DataController.getSectionClass("Shared Procedure");
        headerClass = DataController.getSectionClass("Shared Procedure");
      }

      if (guidelineSummary.annotations) {
        for (let annotation of guidelineSummary.annotations) {
          if (annotation.ShowWaterMark) {
            isExcluded = true;
          }
        }

        bottomBarClass = DataController.getSectionClass(this.props.userTrust);
        if (isExcluded) {
          bottomBarText = DataController.getTrustDisplayName(this.props.userTrust) + " Exclusion";
        } else {
          bottomBarText = DataController.getTrustDisplayName(this.props.userTrust) + " Guidance";
        }
      }

      if (guidelineSummary.GLID === "LAS1480") {
        let test = "";
      }

      if (DataController.isAuthorisableGuideline(guidelineSummary)) {
        headerClass = DataController.getSectionClass(this.props.userTrust);
        if (DataController.isPGD(guidelineSummary)) {
          pgdText = "PGD";
        }
        if (DataController.isPMA(guidelineSummary)) {
          pgdText = "PMA";
        }

        let pgdStatus = DataController.getPGDStatus(
          guidelineSummary,
          this.props.pgdAck,
          this.props.screenProps.pgdTrustInfo
        );

        if (pgdStatus === "InformationOnly") {
          acknowledgementText = "Info only";
          acknowledgementClass = "guidelineCellPGDInformationOnly";
        } else if (
          pgdStatus === "UnauthorisedAcknowledge" ||
          pgdStatus === "UnauthorisedQuizTaken" ||
          pgdStatus === "UnauthorisedTakeQuiz"
        ) {
          acknowledgementText = "Unauthorised";
          acknowledgementClass = "guidelineCellPGDUnauthorised";
        } else if (pgdStatus === "Authorised") {
          acknowledgementText = "Authorised";
          acknowledgementClass = "guidelineCellPGDAuthorised";
        }
      }

      if (guidelineSummary.SupportAcknowledment === true) {
        if (this.props.glAck && guidelineSummary.AcknowledgedTime) {
          let userAcknowledgedDate = new Date(this.props.glAck.timestamp);
          let guidelineAcknowledgmentUpdatedDate = new Date(guidelineSummary.AcknowledgedTime);

          if (userAcknowledgedDate > guidelineAcknowledgmentUpdatedDate) {
            acknowledgementText = "Acknowledged";
            acknowledgementClass = "guidelineCellPGDAuthorised";
          } else {
            acknowledgementText = "Unacknowledged";
            acknowledgementClass = "guidelineCellPGDUnauthorised";
          }
        } else {
          acknowledgementText = "Unacknowledged";
          acknowledgementClass = "guidelineCellPGDUnauthorised";
        }
      }
    }

    let algorithm = this.props.algorithm;
    if (algorithm != null) {
      titleText = algorithm.name;
      headerClass = DataController.getSectionClass("Algorithms");

      if (algorithm.annotations) {
        for (let annotation of algorithm.annotations) {
          if (annotation.ShowWaterMark) {
            isExcluded = true;
          }
        }

        if (isExcluded) {
          bottomBarText = DataController.getTrustDisplayName(this.props.userTrust) + " Exclusion";
        } else {
          bottomBarText = DataController.getTrustDisplayName(this.props.userTrust) + " Guidance";
        }
      }
    }

    if (this.props.inAlgorithmList) {
      headerClass = DataController.getSectionClass("Algorithms");
    }

    if (this.props.screenProps.app === "CFR") {
      if (this.props.algorithm || (this.props.guidelineSummary && DataController.isDrug(this.props.guidelineSummary))) {
        acknowledgementText = "Info only";
        acknowledgementClass = "guidelineCellPGDInformationOnly";
      }
    }

    // if (guideline != null && guideline.trust) {
    //   headerClass = guideline.trust;
    // }

    // set max line number to limit lines so ellipsis show properly
    let maxLineNumber = 5;
    if (lowerText) {
      maxLineNumber -= 1;
    }
    if (bottomBarText) {
      maxLineNumber -= 1;
    }

    // add highlighting to title text if there is a search term
    let titleTextHtml = titleText;
    if (titleText.length > 0 && this.props.searchText) {
      let beginningOfSearchTerm = titleText.toLowerCase().indexOf(this.props.searchText.toLowerCase());
      let endOfSearchTerm = beginningOfSearchTerm + this.props.searchText.length;

      if (beginningOfSearchTerm !== -1) {
        titleTextHtml =
          titleText.substr(0, beginningOfSearchTerm) +
          '<span class="guidelineCellHighlight">' +
          titleText.substr(beginningOfSearchTerm, this.props.searchText.length) +
          "</span>" +
          titleText.substr(endOfSearchTerm, titleText.length);
      }
    }

    let sectionStyle: any = {};
    let sectionColors = this.props.screenProps.sectionColors;
    let sectionColorFound = false;

    if (guidelineSummary) {
      for (let sectionColor of sectionColors) {
        if (sectionColor.name === guidelineSummary.Section) {
          sectionStyle["backgroundColor"] = sectionColor.color;
          sectionColorFound = true;
          break;
        }
      }
    }

    return (
      <div
        className={`guidelineCell ${isExcluded ? "guidelineCellExcluded" : ""}`}
        tabIndex={0}
        role="button"
        onClick={this.cellClicked.bind(this)}
      >
        <div className={`sliver ${sectionColorFound ? "" : headerClass}`} style={sectionStyle} />
        <div className="guidelineCellContents">
          <div className="guidelineCellTopContents">
            <div className="guidelineCellTextContent">
              <div
                className="guidelineCellTitle"
                style={{ WebkitLineClamp: maxLineNumber }}
                dangerouslySetInnerHTML={{
                  __html: titleTextHtml,
                }}
              />
              {lowerText !== "" ? <div className="guidelineCellLowerText">{lowerText}</div> : null}
            </div>

            <div className="guidelineIcons">
              {this.props.bookmarked ? <img className="bookmarkIcon" src={indicatorBookmark} alt="" /> : null}
            </div>
            {this.props.referenceCardImageName != null && this.props.referenceCardImageName !== "" ? (
              <div className="guidelineCellReferenceCardImageContainer">
                <img className="guidelineCellReferenceCardImage" src={this.props.referenceCardImageName} />
              </div>
            ) : null}
          </div>
          {acknowledgementText ? <div className={`${acknowledgementClass}`}>{acknowledgementText}</div> : null}
          {this.props.updated && pgdText === "" ? (
            <div className={`guidelineCellUpdated ${bottomBarText !== "" ? "guidelineCellUpdatedBottomSpace" : ""}`}>
              Updated
            </div>
          ) : null}
          {bottomBarText !== "" ? (
            <div className={`guidelineTrust ${bottomBarClass}`}>
              {bottomBarText}
              <div className="guidelineCellPGDText">{pgdText}</div>
            </div>
          ) : null}
        </div>
      </div>
    );
  }
}

export default GuidelineCell;
